import { render } from "./Schaduals.vue?vue&type=template&id=6e5489d6&scoped=true"
import script from "./Schaduals.vue?vue&type=script&lang=js"
export * from "./Schaduals.vue?vue&type=script&lang=js"

import "./Schaduals.vue?vue&type=style&index=0&id=6e5489d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5489d6"]])

export default __exports__